/**
 * Resolve the deployment-level RAG base URL.
 *
 * Phase 5 of the rag-deployment-config plan replaces the per-user
 * `connections.ragServerUrl` setting with a deployment-level value
 * surfaced via `featureStore.ragProxyBase`. The fallback to `/rag-proxy`
 * keeps Vite's dev proxy and local-Docker nginx working when no env
 * var is set.
 *
 * Components looking up "where do I send RAG requests?" should use
 * this hook (or `getRagProxyBase()` for non-React contexts) instead
 * of reading `useSettingsStore.connections.ragServerUrl`, which has
 * been removed.
 */

import { useFeatureStore } from '@/stores/featureStore'

const DEFAULT_BASE = '/rag-proxy'

export function useRagProxyBase(): string {
  return useFeatureStore(s => s.ragProxyBase) || DEFAULT_BASE
}

/** Non-React accessor (services, event handlers, etc.). */
export function getRagProxyBase(): string {
  return useFeatureStore.getState().ragProxyBase || DEFAULT_BASE
}
